import React, { Component } from 'react';
import Input from '../../elements/Input';
import ModalBody from '../modal/ModalBody';
import ModalControls from '../modal/ModalControls';
import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';
import type { ProjectCategory } from '../../../types';

type State = {
  form: {
    name: string,
    color: string
  }
};

type Props = {
  onSubmit: (payload: { name: string, color: string }) => void,
  onClose: () => void,
  title: string,
  saveButtonText: string,
  disableButtons?: boolean,
  category?: ProjectCategory,
};

const CATEGORY_COLORS = [
  '#F44336',
  '#D32F2F',
  '#E91E63',
  '#FF4081',
  '#C2185B',
  '#FF5722',
  '#FF9800',
  '#FFC107',
  '#FFEB3B',
  '#AFB42B',
  '#8BC34A',
  '#4CAF50',
  '#388E3C',
  '#00796B',
  '#009688',
  '#00BCD4',
  '#2196F3',
  '#1976D2',
  '#3F51B5',
  '#9C27B0',
  '#7B1FA2',
  '#673AB7',
  '#795548',
  '#607D8B',
  '#000000',
];

class CategoryModal extends Component<Props, State> {
  getInitialFormState(category?: ProjectCategory): { color: string, name: string } {
    return {
      name: category ? category.name : '',
      color: category ? category.color : '#000000',
    };
  }

  state: State = {
    form: this.getInitialFormState(this.props.category),
  };

  componentDidUpdate(prevProps: Props) {
    const categoryChanged = prevProps.category !== this.props.category;

    if (categoryChanged) {
      this.setState({
        form: this.getInitialFormState(this.props.category),
      });
    }
  }

  isFormValid(): boolean {
    const { form: { name } } = this.state;

    return name.length > 0;
  }

  handleNameChange(event: any) {
    this.setState({
      form: {
        ...this.state.form,
        name: event.target.value,
      },
    });
  }

  handleColorChange(event: any) {
    this.setState({
      form: {
        ...this.state.form,
        color: event.target.value,
      },
    });
  }

  handleSubmit() {
    const { onSubmit } = this.props;
    const { form } = this.state;
    onSubmit(form);
  }

  render(): React.ReactNode {
    const {
      title, saveButtonText, onClose, disableButtons,
    } = this.props;
    const { form } = this.state;

    return (
      <>
        <ModalHeader title={title} onCloseClick={onClose} />
        <ModalBody>
          <form>
            <div className="form-group">
              <Input
                id="category-name"
                label="Category Name"
                name="name"
                value={form.name}
                onChange={(e) => this.handleNameChange(e)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="color-picker">Category Color</label>
              <div
                id="color-picker"
                className="color-picker-grid"
              >
                {CATEGORY_COLORS.map(color => (
                  <button
                    key={color}
                    type="button"
                    className={`color-option ${form.color === color ? 'selected' : ''}`}
                    style={{ backgroundColor: color }}
                    onClick={() => this.setState({ form: { ...form, color } })}
                  />
                ))}
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <ModalControls
            showEditButton={false}
            isFormValid={!this.isFormValid()}
            onSubmitButtonClick={() => this.handleSubmit()}
            onCloseButtonClick={onClose}
            submitButtonText={saveButtonText}
            disableButtons={disableButtons}
          />
        </ModalFooter>
      </>
    );
  }
}

export default CategoryModal;
